<template>
  <v-card
    flat
    v-if="
      education &&
      education.educationDistanceEducationProviderCourses &&
      education.educationDistanceEducationProviderCourses.length > 0
    "
  >
    <div class="v-item-group v-expansion-panels">
      <div
        class="v-expansion-panel"
        v-for="(providerCourses, providerName) in getTrainingProviderCourses()"
        :key="providerName"
      >
        <div class="v-expansion-panel-header border-bottom">
          <span class="header subtitle-1"
            >{{ $t("labels.education-provider") }}: {{ providerName }}</span
          >
          <div class="v-expansion-panel-header__icon"></div>
        </div>
        <div class="v-expansion-panel-content">
          <div class="v-expansion-panel-content__wrap">
            <div
              v-for="course in providerCourses"
              class="course-desctiption"
              :key="course.id"
            >
              <div
                class="course-desctiption__element"
                v-if="
                  course.distanceEducationProviderCourse &&
                  course.distanceEducationProviderCourse.name
                "
              >
                <span class="course-desctiption__element-header"
                  >{{ $t("ebook.course-name") }}: </span
                >{{ course.distanceEducationProviderCourse.name }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header"
                  >{{ $t("labels.status") }}: </span
                >{{ $t(`ebook.status.${course.status}`) }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header"
                  >{{ $t("labels.approved") }}: </span
                >{{ course.approved ? $t("labels.yes") : $t("labels.no") }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header"
                  >{{ $t("ebook.approval-date") }}: </span
                >{{ course.approvedAt | date }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header"
                  >{{ $t("ebook.teacher") }}: </span
                >{{ course.teacherName }}
              </div>
              <div class="course-desctiption__element">
                <span class="course-desctiption__element-header"
                  >{{ $t("ebook.material-sent") }}: </span
                >{{ course.educationalMaterialSentOn | date }}
              </div>
              <div class="course-desctiption__element" v-if="course.courseOpportunity">
                <span class="course-desctiption__element-header"
                  >{{ $t("ebook.course-opportunity") }}: </span
                >{{ course.courseOpportunity }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-expansion-panels class="progressbar mt-n2" v-for="(course, i) in education.educationDistanceEducationProviderCourses"
        :key="i">
      <v-expansion-panel        
        hide-actions
      >
        <v-expansion-panel-header
          :expand-icon="course.assignments ? '$sl-arrow-down' : ''"
          v-bind:class="{ complete: transformAssignments(course).approved }"
        >
          <v-row align="center" class="spacer" no-gutters>
            <v-col class="subtitle-1 text-uppercase" cols="12">
              <div class="d-flex">
                <div
                  v-if="
                    course.distanceEducationProviderCourse &&
                    course.distanceEducationProviderCourse.name
                  "
                >
                  {{ transformAssignments(course).name }}
                </div>
                <div class="ml-auto mr-1">
                  <v-icon v-if="transformAssignments(course).approved"
                    >$sl-completed</v-icon
                  >
                </div>
              </div>
            </v-col>
            <v-col cols="12">
              <progressLinear
                v-if="
                  transformAssignments(course).assignments &&
                  filter(transformAssignments(course).assignments, ['approved', true])
                "
                class="mt-n1 mb-n2"
                :value="
                  getPercentage(
                    filter(transformAssignments(course).assignments, ['approved', true])
                      .length,
                    transformAssignments(course).assignments.length
                  )
                "
              ></progressLinear>
            </v-col>
          </v-row>
        </v-expansion-panel-header>

        <v-expansion-panel-content>
          <v-container class="pt-0">
            <template>
              <ul>
                <li>
                  <p
                    v-if="
                      transformAssignments(course).assignments &&
                      filter(transformAssignments(course).assignments, ['approved', true])
                    "
                  >
                    {{ apprenticeName != "" ? apprenticeName : $t("company.you") }}
                    {{
                      $t("ebook.education-paneltext1-text", {
                        msg1: filter(transformAssignments(course).assignments, [
                          "approved",
                          true,
                        ]).length,
                        msg2: transformAssignments(course).assignments.length,
                      })
                    }}
                  </p>
                </li>
              </ul>
            </template>
            <v-divider class="fullwidth-17 mt-5 mb-1"></v-divider>
            <v-row class="no-gutters">
              <v-col cols="11" lg="11"></v-col>
              <v-col cols="1" lg="1" class="smallTitle align-end text-no-wrap">
                <div>{{ $t("ebook.subtitle3") }}</div>
              </v-col>
            </v-row>

            <div
              v-for="assignment in transformAssignments(course).assignments"
              :key="assignment.id"
            >
              <template class="d-flex">
                <v-row
                  v-bind:class="[
                    assignment.approved ? active : '',
                    elementRow,
                    noGutters,
                  ]"
                >
                  <v-col cols="11" class="d-flex">
                    <div class="itemName">{{ assignment.name }}</div>
                    <!-- <v-icon class="ml-1 mt-2" @click="clickInfo(assignment, assignment.name)">$sl-info</v-icon> -->
                  </v-col>

                  <v-col cols="1" class="smallTitle">
                    <v-icon v-if="assignment.approved">$sl-completed</v-icon>
                  </v-col>
                </v-row>
              </template>
            </div>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import progressLinear from "@/components/Common/ProgressLinear";
import { Utilities } from "@/components/mixins";
import filter from "lodash/filter";
import get from "lodash/get";

// @group Common
// Styled DistanceEducationProviderCourses component
export default {
  name: "DistanceEducationProviderCourses",
  mixins: [Utilities],
  props: {
    //has education object
    education: Object,
    apprenticeName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      active: "active",
      elementRow: "element-row",
      noGutters: "no-gutters",
    };
  },
  created() {
    //console.log("education::", this.education);
  },
  components: {
    progressLinear,
  },
  computed: {},
  methods: {
    filter: filter,
    /* clickInfo(item, parentName) {
      item.parentName = parentName
      this.$emit('modalToogle', item)
    }, */
    transformAssignments(course) {
      if (!course) return;
      let arr = {
        approved: course.approved,
        assignments: course.assignments ? course.assignments : [],
        name: course.distanceEducationProviderCourse
          ? course.distanceEducationProviderCourse.name
          : "",
      };
      return arr;
    },
    getTrainingProviderCourses() {
      const educationProviderCourses = get(
        this.education,
        "educationDistanceEducationProviderCourses",
        []
      );
      const mapedByProvider = educationProviderCourses.reduce((acc, el) => {
        const providerName = get(
          el,
          "distanceEducationProviderCourse.distanceEducationProvider.name",
          ""
        );
        if (acc[providerName]) {
          acc[providerName].push(el);
        } else {
          acc[providerName] = [el];
        }
        return acc;
      }, {});
      return mapedByProvider;
    },
  },
};
</script>

<style lang="scss" scoped></style>
